import { Accordion } from '@europrocurement/flexy-components';
import { CustomOptionResolvers, FlexyForm, FormStructure } from '@europrocurement/flexy-form';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import type { SxProps } from '@mui/system';

export type AccordionJsonFormProps = {
    structure: FormStructure[];
    customOptionResolvers?: CustomOptionResolvers;
    accordionSx?: SxProps;
    defaultValues: Record<string, unknown>;
    expanded?: boolean;
    onChange: (data: Record<string, unknown>) => void;
};

const AccordionJsonForm: React.FunctionComponent<AccordionJsonFormProps> = function ({
    structure,
    customOptionResolvers,
    accordionSx = {},
    defaultValues,
    expanded = false,
    onChange: handleChange,
}) {
    const formContext = useForm({
        mode: 'onTouched',
        defaultValues,
        values: defaultValues,
    });
    const { getValues, watch } = formContext;

    const getTitle = () => {
        const title = structure.find((struct) => struct.type === 'header');

        return title?.label || '';
    };

    const getStructureFiltered = () => structure.filter((struct) => struct.type !== 'header');

    useEffect(() => {
        const subscription = watch(() => {
            handleChange(getValues());
        });

        return () => subscription.unsubscribe();
    }, [structure, watch, handleChange, getValues]);

    return (
        <Accordion
            title={getTitle()}
            sx={accordionSx}
            expanded={expanded}
        >
            <FlexyForm
                formContext={formContext}
                formStructure={getStructureFiltered()}
                onSubmit={handleChange}
                customOptionResolvers={customOptionResolvers}
                submitButton={{ displayed: false }}
            />
        </Accordion>
    );
};

export default AccordionJsonForm;
